import React from "react";



export function ResizeableContainer({ children,direction="row" }) {
  var isColumn= direction=="column"
  return <div css={`
    width:100%;
    display:flex;
    ${isColumn ? 'flex-direction:column' : ''};
    height:100%;
    `}>{children}</div>;
}
